import { tv, type VariantProps } from "@/lib/utils/tv"

const countBadge = tv({
  base: "font-display inline-flex items-center justify-center rounded-full font-bold",
  variants: {
    tone: {
      brand: "bg-brand",
      outline: "border-line-brand border font-normal tabular-nums",
    },
    size: {
      base: "text-caption h-4 min-w-4 px-100",
      compact: "text-badge-compact h-badge-compact min-w-badge-compact px-50 ring-2 ring-surface",
      pad: "text-body-xs h-5 min-w-7 px-200",
    },
  },
  compoundVariants: [
    { tone: "brand", size: ["base", "pad"], class: "text-fg-inverted" },
    { tone: "outline", size: ["base", "pad"], class: "text-fg-brand" },
  ],
  defaultVariants: { tone: "brand", size: "base" },
})

interface CountBadgeProps extends VariantProps<typeof countBadge> {
  count: number
  minimumDigits?: number
  className?: string
}

export const CountBadge = ({ count, minimumDigits = 1, tone, size, className }: CountBadgeProps) =>
  count > 0 ? <span className={countBadge({ tone, size, className })}>{String(count).padStart(minimumDigits, "0")}</span> : null
